import { reactive, location } from 'cdui-js';
import { DiFiNavBar } from '../../../../../components/DiFi/DiFiNavBar';
import { DiFiButton } from '../../../../../components/DiFi/DiFiButton';
import {
  DiFiQuestionnaire,
  type QuestionItem,
  type QuestionAnswer,
} from '../../../../../components/DiFi/DiFiQuestionnaire';
import { isW8benEmbeddedInApp, w8benUrlKeepEmbed } from './w8benEmbed';

const QUESTIONS: QuestionItem[] = [
  {
    id: 'q1',
    title: '在更新W-8表格前，请确认阁下现时是否美国公民(U.S.Citizen)或外国居民(Resident Alien)(统称美国人)?',
    type: 'radio',
    required: true,
    options: [
      { value: 'true', label: 'a. 是' },
      { value: 'false', label: 'b. 否' },
    ],
  },
];

export const W8Ben = () => {
  const state = reactive({
    answers: [] as QuestionAnswer[],
    allRequiredAnswered: false,
  });

  const handleChange = (answers: QuestionAnswer[], allRequiredAnswered: boolean) => {
    state.answers = answers;
    state.allRequiredAnswered = allRequiredAnswered;
  };

  const goResult = () => {
    const v = state.answers[0]?.value;
    location.routeTo(w8benUrlKeepEmbed(`/w8ben-result?result=${v}`));
  };

  const embedded = isW8benEmbeddedInApp();
  const pageClass = embedded ? 'page-wrapper-no-header flex-column bg-c' : 'page-wrapper-with-header flex-column bg-c';

  return (
    <div class={pageClass}>
      {embedded ? null : <DiFiNavBar title="W-8BEN确认" fixed onClickLeft={() => history.back()} />}

      <div class="flex-1 overflow-auto padding-x">
        <DiFiQuestionnaire questions={QUESTIONS} onChange={handleChange} />
      </div>

      <div class="padding-x padding-b-L">
        <DiFiButton text="提交" disabled={!state.allRequiredAnswered} onClick={goResult} />
      </div>
    </div>
  );
};
